var $ = require('jquery');
module.exports = {

	//Takes in full JSON file
	//returns the total count for all types
	getTypeCounts: function(data){
		var types = {};
		for (var key in data) {
			var type = data[key]['type_'];
			if(type in types){
				types[type] += 1;
			}
			else {
				types[type] = 1;
			}
		}
		console.log(types);
		return types;

	},


	makePie: function(data) {
    //Based on https://bl.ocks.org/mbostock/3887235


		var checkExist = setInterval(function(){
      console.log("in make pie")
      if ($('#bar-svg').length) {
        setTimeout(function(){
          draw();
        }, 100);
        clearInterval(checkExist);
      }
    }, 200);

		var draw = function() {

	    var d3 = require("d3");

	    var sentimentCount = [{"type" : "positive", "count" : 0}, {"type" : "neutral", "count" : 0}, {"type" : "negative", "count" : 0}]
	    var sentimentCount = []

	    for (var key in data) {
	      var typeData = {}
	      typeData["type"] = key;
	      typeData["count"] = data[key];
	      sentimentCount.push(typeData);
	    }
	    console.log("piedata", sentimentCount);
	    var svg = d3.select("#bar-svg");
		svg.html("");
	    var width = 0.8 * $('#pie-svg').width();
	    var height = 0.8 * 500;
	    var radius = Math.min(width, height) / 2;
	    var g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

					var color = d3.scaleOrdinal()
			      .domain(["bias", "conspiracy", "fake", "junksci", "rumors", "satire", "state", "hate", "clickbait", "test", "bs"])
			      .range(["#98abc5", "#d0743c", "#ff8c00", "#88d03b", "#5b3bd0", "#d03bc8", "#d03b3b", "#37c646", "#ffdd47", "#f22e2e", "#9187ff"]);

			    var pie = d3.pie()
			        .sort(null)
			        .value(function(d) { return d.count; });

			    var path = d3.arc()
			        .outerRadius(radius - 10)
			        .innerRadius(0);

			    var label = d3.arc()
			        .outerRadius(radius - 40)
			        .innerRadius(radius - 40);

			    var arc = g.selectAll(".arc")
			      .data(pie(sentimentCount))
			      .enter().append("g")
			        .attr("class", "arc");

			    arc.append("path")
			        .attr("d", path)
			        .attr("fill", function(d) { return color(d.data.type); });

			    arc.append("text")
			        .attr("transform", function(d) { return "translate(" + label.centroid(d) + ")"; })
			        .attr("dy", "0.35em")
							.attr("class", "pie-text")
					.attr("font-size", "18px")
			        .text(function(d) { return d.data.type; });
			  }
			}
}



// WEBPACK FOOTER //
// ./src/barchart.js